<!-- The phone sheet spaces the sections out more than the desktop aside. -->
<div class="flex flex-col gap-4.5 not-expanded:gap-6">
  @if (sortable()) {
    <section class="flex flex-col gap-0.5" [attr.aria-labelledby]="uid + '-sort'">
      <h2 [id]="uid + '-sort'" [class]="headingClasses">Sort by</h2>
      @for (order of sortOrders; track order) {
        @let selected = order === library.sortOrder();
        <button
          #sortOption
          mibListItem
          type="button"
          [active]="selected"
          [attr.aria-pressed]="selected"
          (click)="library.sortOrder.set(order)">
          <span class="truncate">{{ sorts[order].label }}</span>
          @if (selected) {
            <svg mib-icon name="check" class="ml-auto"></svg>
          }
        </button>
      }
    </section>
  }

  <section class="flex flex-col gap-2" [attr.aria-labelledby]="uid + '-specialty'">
    <h2 [id]="uid + '-specialty'" [class]="headingClasses">Specialty</h2>
    <mib-filter-chips
      class="flex-wrap"
      aria-label="Filter the library by specialty"
      [chips]="categoryChips"
      [value]="library.categoryRow()"
      (valueChange)="library.setCategoryRow($event)"></mib-filter-chips>
  </section>

  <section class="flex flex-col gap-2" [attr.aria-labelledby]="uid + '-date'">
    <h2 [id]="uid + '-date'" [class]="headingClasses">Date</h2>
    <mib-filter-chips
      class="flex-wrap"
      aria-label="Filter the library by date"
      size="sm"
      appearance="solid"
      [multiple]="false"
      [chips]="periodChips"
      [value]="periodRow()"
      (valueChange)="choosePeriod($event)"></mib-filter-chips>
    <div class="flex flex-col gap-3">
      <div class="flex flex-col gap-1">
        <label [for]="uid + '-from'" class="text-mib-branding-900 text-[13px]/4.5 font-medium"
          >Start date</label
        >
        <mib-datepicker
          [inputId]="uid + '-from'"
          panelLabel="Choose the first day"
          [max]="library.range().end"
          [formControl]="from"></mib-datepicker>
      </div>
      <div class="flex flex-col gap-1">
        <label [for]="uid + '-to'" class="text-mib-branding-900 text-[13px]/4.5 font-medium"
          >End date</label
        >
        <mib-datepicker
          [inputId]="uid + '-to'"
          panelLabel="Choose the last day"
          [min]="library.range().start"
          [formControl]="to"></mib-datepicker>
      </div>
    </div>
  </section>

  <section class="flex flex-col gap-2" [attr.aria-labelledby]="uid + '-publication'">
    <h2 [id]="uid + '-publication'" [class]="headingClasses">Publication</h2>
    <mib-filter-chips
      class="flex-wrap"
      aria-label="Filter the library by publication"
      size="sm"
      appearance="solid"
      [multiple]="false"
      [chips]="publicationChips"
      [value]="publicationRow()"
      (valueChange)="choosePublication($event)"></mib-filter-chips>
  </section>
</div>
